import type { PropsWithChildren } from "react";

function MinimalLayout({ children }: PropsWithChildren) {
  return (
    <main className="flex min-h-screen justify-center bg-background text-foreground">
      <div className="w-full max-w-[30rem] px-4 py-4">{children}</div>
    </main>
  );
}

export { MinimalLayout };
